import React, { useState, useEffect } from 'react';
import {
  Modal,
  Radio,
  Card,
  Input,
  Divider,
  Typography,
  List,
  Button,
  Menu,
  Form,
  Avatar,
  Select,
  message,
  Upload,
  Space, Spin
} from "antd";
import './index.css';
import {
    UploadOutlined,
    LoadingOutlined,
    PlusOutlined
} from '@ant-design/icons';
import {
    uploadImgRequest,
    getBotRequest,
    createKcs,
} from './api';

import TextPage from '../textPage/index';
import { updateBotKnowledgeRequest } from "../addKCSDialog/api";
import { API_URL } from '../../../../util/constants';
import Cookies from 'js-cookie';
// const API_URL = 'http://ygbhpy.gamepku.com';
const { TextArea } = Input;
const { Title, Paragraph } = Typography;
const { Meta } = Card;
const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};
const SelectKCSModal = (props) => {


    const [iconImg, setIconImg] = useState('');
    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState('1');
    const [form] = Form.useForm();
    const [nameCount, setNameCount] = useState(0);
    const [descCount, setDescCount] = useState(0);

    const [dataList, setDataList] = useState([]);

    const [zhishikuType, setZhishikuType] = useState('0');
    const [importType, setImportType] = useState('0');
    const [myZhishikuList, setMyZhishikuList] = useState(props.myZhishikuList);
    const [isLoading, setIsLoading] = useState(false);


    const handleRadioChange = (e) => {
      setZhishikuType(e.target.value); // 更新状态
      console.log('新选中项 value:', e.target.value);

      //setImportType('0');

    };

  const handleImportChange = (e) => {
    setImportType(e.target.value); // 更新状态
    console.log('新选中项 value:', e.target.value);
  };

  const getBotInfo = () => {
    if(props.bot_id){
      getBotRequest(props.bot_id, (data) => {
        console.log(data);
        if (data.ret == 1) {
          let objData = data.botInfo;
          setMyZhishikuList(objData.knowledge.knowledge_infos);

        }
      });
    }else{
      console.log('主页直接创建知识库，无绑定bot_id')
    }


  }

    useEffect(() => {
      getBotInfo();
    }, []);

    const [activeTab, setActiveTab] = useState('template');
    const [disableCreate, setDisableCreate] = useState(true);
    
    const [visibleCreate, setVisibleCreate] = useState(false);
    const [space_id, setSpace_id] = useState(props.space_id);

    const onCancelCreate = () => {
        props.onCancelCreate();
        setVisibleCreate(false);
    };
    const createFn = () => {
        setVisibleCreate(true);
    };
    const [tishiValue, setTishiValue] = useState(
        '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3'
    );
    const changeTishiFn = (e) => {
        console.log(e.target.value, 'e');
        setTishiValue(e.target.value);
    };
    const clickAddTishi = () => {
        //setValue(tishiValue, false);
    };

    const [fileList, setFileList] = useState([]);
    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    };
    const handleChange = (info) => {
        console.log(info, 'info');
        if (info.fileList.length == 2) {
            setFileList([info.fileList[1]]);
        } else {
            setFileList(info.fileList);
        }
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, (url) => {
                setLoading(false);
                setImageUrl(url);
            });
        }
    };
    const customRequest = async ({ file, onSuccess, onError }) => {
        try {
            // 生成新文件名（可根据需求修改）
            const fileExt = file.name.substr(file.name.lastIndexOf('.') + 1);
            const newFileName = `img_${Date.now()}_${Cookies.get('user_login')}.${fileExt}`;

            // 调用你的上传接口
            await uploadImgRequest(file, newFileName, (data) => {
                if (data.ret == 1) {
                    // const fileUrl = `${API_URL}/icons/${newFileName}`;
                    // onSuccess({ ...file, url: fileUrl }, file);
                    // onUploadSuccess?.(fileUrl); // 可选：通知父组件上传成功
                    file.url = API_URL + '/icons/' + newFileName;
                    // file.name = newFileName
                    onSuccess(file);
                    setIconImg(data.imgInfo.id);
                } else {
                    onError(data);
                    message.error('上传失败: ' + (data.message || '未知错误'));
                }
            });
        } catch (error) {
            onError(error);
            message.error('上传失败: ' + error.message);
        }
    };
    const [imageUrl, setImageUrl] = useState();
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type='button'
        >
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );
    return (
        <div>
            <Modal
                maskClosable={false}
                title='创建知识库'
                visible={true}
                okText={props.bot_id?'创建并导入':'创建'}
                cancelText='取消'
                onCancel={onCancelCreate}
                onOk={() => {

                    form.validateFields()
                        .then((values) => {
                            console.log(values, 'valu');
                          if (iconImg) {

                            setIsLoading(true)

                            createKcs(
                              {
                                space_id: space_id,
                                name: values.name,
                                format_type: zhishikuType,
                                description: values.description,
                                icon_file_id: iconImg,
                              },
                              (res) => {
                                if (res.ret == 1) {
                                  sessionStorage.setItem(
                                    'SET_DATASETID',
                                    res.data.dataset_id
                                  );
                                  sessionStorage.setItem('SET_TYPE_SELECT', values.prompt);
                                  setVisibleCreate(false);
                                  props.onSuccess(zhishikuType,importType, res.data.dataset_id);

                                  if(props.bot_id){//创建并导入
                                    var bean = {id:res.data.dataset_id, name:res.data.name}
                                    console.log(bean)

                                    var list = myZhishikuList;
                                    list.push(bean)
                                    console.log(list)
                                    var listNew = myZhishikuList.map(item => item.id);
                                    console.log(listNew)

                                    updateBotKnowledgeRequest({
                                        "bot_id": props.bot_id,
                                        "knowledge": {
                                          "dataset_ids": listNew,
                                          "auto_call": true,
                                          "search_strategy": 0
                                        }
                                      },
                                      (res) => {
                                        if (res.ret == 1) {
                                          message.success("智能体更新成功！");
                                          setIsLoading(false);
                                          props.onSuccessImport()
                                        }else{
                                          setIsLoading(false);
                                        }
                                      }
                                    );


                                  }else{
                                    setIsLoading(false)
                                  }

                                }
                              }
                            );
                            form.resetFields();
                          }else{
                            message.error('请上传图片');
                          }
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                          setIsLoading(false)
                        });
                }}
                width={600}
            >
                <Form
                    form={form}
                    layout='vertical'
                    initialValues={{
                        name: '',
                        description: '',
                        prompt: '0',
                    }}
                >
                    <Form.Item
                        label='知识库类型'
                        name='format_type'
                        // rules={[
                        //     { required: true, message: '请输入提示词名称' },
                        //     { max: 20, message: '不能超过20个字符' },
                        // ]}
                    >
                        <Radio.Group  defaultValue='0' value={zhishikuType} onChange={handleRadioChange}>
                            <Radio value='0'>文本类型</Radio>
                            <Radio value='2'>照片类型</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        label='知识库名称'
                        name='name'
                        rules={[
                            { required: true, message: '知识库名称不能为空' },
                            { max: 100, message: '不能超过20个字符' },
                        ]}
                    >
                        <Input
                            placeholder='请输入提示词名称'
                            maxLength={20}
                            showCount={{
                                formatter: ({ count }) => `${count}/100`,
                            }}
                            onChange={(e) => setNameCount(e.target.value.length)}
                        />
                    </Form.Item>

                    <Form.Item
                        label='知识库描述'
                        name='description'
                        rules={[{ max: 500, message: '不能超过50个字符' }]}
                    >
                        <Input.TextArea
                            placeholder='请输入知识库简介'
                            maxLength={50}
                            showCount={{
                                formatter: ({ count }) => `${count}/500`,
                            }}
                            rows={3}
                            onChange={(e) => setDescCount(e.target.value.length)}
                        />
                    </Form.Item>

                    <Form.Item
                        label='导入类型'
                        name='prompt'
                        rules={[{ required: true, message: '请选择导入类型' }]}
                    >

                      {zhishikuType=='0'?
                        <Radio.Group  defaultValue='0' value={importType} onChange={handleImportChange}>
                          <Space direction='vertical'>
                            <Radio value='0'>
                              本地文档（上传 PDF, TXT, MD, DOC, DOCX 格式的本地文件）
                            </Radio>
                            <Radio value='1'>在线数据（获取在线网页内容）</Radio>
                            {/*<Radio value='2'>自定义（自定义内容，支持创建&编辑）</Radio>*/}
                          </Space>
                        </Radio.Group>
                      :<Radio.Group  defaultValue='0' value={importType} onChange={handleImportChange}>
                          <Space direction='vertical'>
                            <Radio value='0'>
                              本地图片（上传 .jpg、.jpeg、.png格式）
                            </Radio>
                          </Space>
                        </Radio.Group>}

                    </Form.Item>

                    <Form.Item label={<span className='touxiang'>图标</span>} name='avatar'>
                        <Upload
                            fileList={fileList}
                            name='avatar'
                            listType='picture-card'
                            className='avatar-uploader'
                            beforeUpload={beforeUpload}
                            onChange={handleChange}
                            customRequest={customRequest}
                            showUploadList={true}
                        >
                            {/*{imageUrl ? (*/}
                                {/*<img*/}
                                    {/*src={imageUrl}*/}
                                    {/*alt='avatar'*/}
                                    {/*style={{*/}
                                        {/*width: '100%',*/}
                                    {/*}}*/}
                                {/*/>*/}
                            {/*) : (*/}
                                {/*uploadButton*/}
                            {/*)}*/}
                          {fileList.length >= 1? null :
                            (uploadButton)
                          }
                        </Upload>
                        <div style={{ marginTop: 8 }}>只支持.jpg、.jpeg、.png格式</div>
                    </Form.Item>
                </Form>


              {isLoading?
                <Spin
                  size="large"
                  style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 10000000000
                  }}/>:null}

            </Modal>

        </div>
    );
};

export default SelectKCSModal;
